// Quando è successo, come lo dice WhatsApp: l'ora per oggi, «ieri», il giorno
// della settimana fino a una settimana fa, poi la data. Con la sola ora una
// chat di marzo sembrava di stamattina (29/09/2026).
const GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

function inizioGiorno(data) {
  return new Date(data.getFullYear(), data.getMonth(), data.getDate());
}

export function quando(valore, adesso = new Date()) {
  if (!valore) return '';
  const data = new Date(valore);
  if (Number.isNaN(data.getTime())) return '';
  const giorni = Math.round((inizioGiorno(adesso) - inizioGiorno(data)) / 86400000);
  if (giorni <= 0) return data.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  if (giorni === 1) return 'ieri';
  if (giorni < 7) return GIORNI[data.getDay()];
  return data.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
